import { prop } from 'ramda'
import React from 'react'

import { setProjectId } from '../../../../utils/session/sessionStorage'
import { useNavigation } from '../../../../utils/contexts/NavigationContext'
import { useQrcode } from '../../_load/QrcodeLoader'

const InactiveQrcodeRedirect = ({ children }) => {
  const navigate = useNavigation()
  const qrcode = useQrcode() || {}
  const active = prop('activated', qrcode)

  React.useEffect(() => {
    if (!active) {
      setProjectId(qrcode.projectId)
      navigate(`/qrcodes/${qrcode.id}/activate`)
    }
  }, [])

  if (!active) return false
  return children
}

export default InactiveQrcodeRedirect
